import { initializeApollo } from 'lib/apolloClient';
import BlockMix from '@/components/BlockMix/BlockMix';

import { getGlobalData } from 'lib/global.js';
import { getEntityBlocks } from 'gql/common/blocks';
import { CORE_WORK_FIELDS, CORE_WORK_FIELDS_KEY, WORKS_SLUGS } from 'gql/works';
import { GetStaticPropsContext } from 'next';
import { Work } from 'generated-graphql';
import appConfig from '@/app.config';

export default function WorkDetails({ pageBlocks, works }: { pageBlocks: Work, works: Work[] }) {
  return (
    <>
      <div style={{ marginTop: 0 }}>
        <BlockMix
          blocksData={pageBlocks?.editorBlocks}
          acfData={pageBlocks?.builder?.sections} />
      </div>
    </>
  );
}

export async function getStaticPaths() {
  const apolloClient = initializeApollo();
  const allWorks = await apolloClient.query({
    query: WORKS_SLUGS,
  });

  const data = allWorks?.data?.works.nodes || [];

  return {
    paths:
      data.map((node: Work) => `/work/${node.slug}`) || [],
    fallback: 'blocking',
  };
}

export async function getStaticProps(context: GetStaticPropsContext) {
  const { params } = context;
  const apolloClient = initializeApollo();
  const pageBlocks = await apolloClient.query({
    query: getEntityBlocks('work', CORE_WORK_FIELDS, CORE_WORK_FIELDS_KEY),
    variables: {
      id: params?.slug,
      idType: 'SLUG',
      asPreview: false,
    },
  });
  const pageProps = {
    pageBlocks: pageBlocks?.data?.work,
  };

  return await getGlobalData(pageProps, apolloClient, {
    revalidate: appConfig.revalidate
  });
}
